import React from "react";

import { Menu } from "@blueprintjs/core";

import styles from "./SidebarGroup.module.scss";

function SidebarGroup({ title, children }) {
  return (
    <Menu className={styles.sidebarGroup}>
      {!!title && (
        <div className={styles.titleWrapper}>
          <h3 className={styles.title}>{title.toUpperCase()}</h3>
        </div>
      )}
      {children}
    </Menu>
  );
}

export default SidebarGroup;
